import { useI18n } from '../../i18n';
import { Button } from './ui/button';

export function BillingPricingStatus({ loading, error, retry }: { loading: boolean; error: Error | null; retry: () => void }) {
  const { t } = useI18n();
  if (!loading && !error) return null;
  return <div className="mb-6 rounded-xl bg-slate-50 px-4 py-3 text-sm text-slate-700" role="status" aria-live="polite">
    <p>{t(loading ? 'billing.pricingLoading' : 'billing.pricingUnavailable')}</p>
    {error && <Button variant="outline" onClick={retry} className="mt-3">{t('billing.retry')}</Button>}
  </div>;
}
